import type { JSX } from 'react';

import { INACTIVE_COLOR } from '../../enums/Activities';
import { TooltipWrapper } from '../../onboarding/TooltipWrapper';
import RioglyphIcon from '../../wrapper/RioglyphIcon';

export const EmptyDataIcon = (): JSX.Element => (
    <RioglyphIcon color={INACTIVE_COLOR} type={'question-sign'} size={'larger'} />
);

interface EmptyDataIconWithTooltipProps {
    tooltipId?: string;
}

export const EmptyDataIconWithTooltip = ({
    tooltipId = 'intl-msg:timed.common.emptyDataIconMessage',
}: EmptyDataIconWithTooltipProps = {}): JSX.Element => (
    <TooltipWrapper tooltipId={tooltipId}>
        <span>
            <RioglyphIcon color={INACTIVE_COLOR} type={'question-sign'} size={'larger'} />
        </span>
    </TooltipWrapper>
);

export const EmptyDataMultiManning = (): JSX.Element => (
    <TooltipWrapper tooltipId={'intl-msg:timed.sidebar.multiManningEmptyDataIconMessage'}>
        <div>
            <RioglyphIcon color={INACTIVE_COLOR} type={'question-sign'} size={'larger'} />
        </div>
    </TooltipWrapper>
);

export const EmptyDataUnknownVehicle = (): JSX.Element => (
    <TooltipWrapper tooltipId={'intl-msg:timed.driving-time-table.noPermissionToSeeVehicle'}>
        <span>
            <RioglyphIcon color={INACTIVE_COLOR} type={'question-sign'} size={'larger'} />
        </span>
    </TooltipWrapper>
);
